export const rotateMap = {
    up: { transform: 'rotate(-90deg)' },
    left: { transform: 'rotate(180deg)' },
    down: { transform: 'rotate(90deg)' },
    right: {},
};
export const arrowRotateMap = {
    up: {},
    down: { transform: 'rotate(180deg)' },
};
